<template>
  <div>
    <iframe height="360px" width="380px" :src="adminLoginFrameUrl"></iframe>
  </div>
</template>

<script>
import JwtUtilService from '@/services/jwt.util.service'
import Base64 from 'crypto-js/enc-base64'
import sha256 from 'crypto-js/sha256'

export default {
  name: 'Login',

  data() {
    return {
      adminLoginFrameUrl: '',
      currentLang: this.$i18n.locale,
    }
  },

  mounted() {
    // If running inside an iframe, skip login entirely
    // Auth will be handled via postMessage INIT_AUTH from parent
    if (window.self !== window.top) {
      console.log('Inside iframe — skipping login flow')
      return
    }

    const urlLang = this.$route.query.lang
    const storedLang = this.safeGetStorage('lang')

    this.currentLang = urlLang || storedLang || 'en'
    this.safeSetStorage('lang', this.currentLang)
    this.$i18n.locale = this.currentLang

    const clientID = this.$config.keyCloakClientId
    const keycloakURL = this.$config.keyCloakURL
    console.log('🚀 ~ Login.vue ~ clientID:', clientID)
    console.log('🚀 ~ Login.vue ~ keycloakURL:', keycloakURL)

    JwtUtilService.removeToken('rekab')
    JwtUtilService.setClientID(clientID)
    JwtUtilService.removeCodeChallenge()
    JwtUtilService.removeCodeVerifier()
    JwtUtilService.removeIdToken()

    this.buildLoginUrl()
  },

  watch: {
    '$route.query.lang'(newLang) {
      if (window.self !== window.top) return
      if (newLang) {
        this.currentLang = newLang
        this.safeSetStorage('lang', newLang)
        this.$i18n.locale = newLang
        this.buildLoginUrl()
      }
    },
  },

  methods: {
    safeGetStorage(key) {
      try {
        return localStorage.getItem(key)
      } catch (e) {
        console.warn('localStorage.getItem blocked:', e)
        return null
      }
    },

    safeSetStorage(key, value) {
      try {
        localStorage.setItem(key, value)
      } catch (e) {
        console.warn('localStorage.setItem blocked:', e)
      }
    },

    buildLoginUrl() {
      // Guard: never run inside an iframe
      if (window.self !== window.top) return

      try {
        const clientID = this.$config.keyCloakClientId
        const keycloakURL = this.$config.keyCloakURL

        JwtUtilService.removeToken('rekab')
        JwtUtilService.removeCodeChallenge()
        JwtUtilService.removeCodeVerifier()
        JwtUtilService.removeIdToken()

        const code_verifier = this.generateRandomString()
        const code_challenge = encodeURI(Base64.stringify(sha256(code_verifier)))
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/, '')

        JwtUtilService.setCodeVerifier(code_verifier)
        JwtUtilService.setCodeChallenge(code_challenge)

        this.adminLoginFrameUrl =
          keycloakURL +
          `/auth?client_id=${clientID}` +
          `&redirect_uri=${window.location.origin}/callback` +
          `&response_type=code` +
          `&scope=openid` +
          `&code_challenge=${code_challenge}` +
          `&code_challenge_method=S256` +
          `&loginType=username` +
          `&showForgotPassword=false` +
          `&ui_locales=${this.currentLang}`
      } catch (e) {
        console.error('buildLoginUrl error:', e)
      }
    },

    generateRandomString() {
      const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      for (let i = 0; i < 44; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
      }
      return result
    },
  },
}
</script>

<style lang="css" scoped>
.login-container {
  position: relative;
}
</style>
